import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { TopicsComponent } from './topics/topics.component';
import { TeacherComponent } from './teacher/teacher.component';
import { TeacherGuard } from './teacher-guard.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { StartComponent } from './start/start.component';

/** Defines all the top-level Routes */
const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'topics', component: TopicsComponent },
  { path: 'login', component: LoginComponent },
  { path: 'teacher', component: TeacherComponent, canActivateChild: [TeacherGuard], canActivate: [TeacherGuard] },
  { path: 'help', component: StartComponent},
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  declarations: [],
  exports: [RouterModule]
})


export class AppRoutingModule { }
